<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full justify-center">
            <invite-target-access
                :teamId="props.teamId"
                :inviteId="props.inviteId"
                :inviteEmail="props.inviteEmail"
                :inviteRole="props.inviteRole"
                :isKiosk="true"
            />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import InviteTargetAccess from '~/components/settings/teams/membership/invite/InviteTargetAccess.vue';

const props = defineProps<{
    teamId: number;
    inviteId: number | null;
    inviteEmail: string;
    inviteRole: string;
}>();
</script>
